import * as React from "react";
const SvgEmptyStateAssetMenu = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 168.508,
	height: 151.235,
	viewBox: "0 0 168.508 151.235",
	...props
}, /* @__PURE__ */ React.createElement("g", {
	id: "Group_27",
	"data-name": "Group 27",
	transform: "translate(-0.006 -0.006)"
}, /* @__PURE__ */ React.createElement("path", {
	id: "Path_669",
	"data-name": "Path 669",
	d: "M295.281,99.394l-5.483,1.414-67.552,17.42-5.483,1.414a10.381,10.381,0,0,0-7.452,12.631l23.775,92.2a10.381,10.381,0,0,0,12.631,7.452l.014,0,78.489-20.241.014,0a10.381,10.381,0,0,0,7.452-12.63l-23.775-92.2A10.381,10.381,0,0,0,295.281,99.394Z",
	transform: "translate(-208.978 -99.06)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_670",
	"data-name": "Path 670",
	d: "M306.9,113.154l-6.494,1.675-65.529,16.9-6.494,1.675a7.393,7.393,0,0,0-5.307,8.994l23.775,92.2a7.393,7.393,0,0,0,8.995,5.307l.014,0,78.489-20.241.014,0a7.393,7.393,0,0,0,5.306-8.994l-23.775-92.2A7.393,7.393,0,0,0,306.9,113.154Z",
	transform: "translate(-219.847 -109.929)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_671",
	"data-name": "Path 671",
	d: "M437.764,240.187l-39.706,10.239a1.727,1.727,0,1,1-.862-3.344L436.9,236.842a1.727,1.727,0,1,1,.862,3.344Z",
	transform: "translate(-355.619 -207.106)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_672",
	"data-name": "Path 672",
	d: "M451.415,258.122l-46.6,12.018a1.727,1.727,0,0,1-.862-3.344l46.6-12.018a1.727,1.727,0,1,1,.862,3.344Z",
	transform: "translate(-360.917 -221.177)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_673",
	"data-name": "Path 673",
	d: "M468.032,357.56,428.326,367.8a1.727,1.727,0,0,1-.862-3.344l39.706-10.239a1.727,1.727,0,0,1,.862,3.344Z",
	transform: "translate(-379.365 -299.189)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_674",
	"data-name": "Path 674",
	d: "M481.684,375.5l-46.6,12.018a1.727,1.727,0,0,1-.862-3.344l46.6-12.018a1.727,1.727,0,0,1,.862,3.344Z",
	transform: "translate(-384.663 -313.26)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_675",
	"data-name": "Path 675",
	d: "M498.3,474.933,458.6,485.172a1.727,1.727,0,1,1-.862-3.344l39.706-10.239a1.727,1.727,0,1,1,.862,3.344Z",
	transform: "translate(-403.111 -391.271)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_676",
	"data-name": "Path 676",
	d: "M511.952,492.869l-46.6,12.018a1.727,1.727,0,1,1-.862-3.344l46.6-12.018a1.727,1.727,0,1,1,.862,3.344Z",
	transform: "translate(-408.41 -405.342)",
	fill: "#f2f2f2"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_677",
	"data-name": "Path 677",
	d: "M307.786,297.334l-14.052,3.624a.829.829,0,0,1-1.009-.6L289.5,287.855a.829.829,0,0,1,.6-1.009l14.051-3.624a.829.829,0,0,1,1.009.6l3.226,12.508A.829.829,0,0,1,307.786,297.334Z",
	transform: "translate(-272.125 -243.516)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_678",
	"data-name": "Path 678",
	d: "M338.055,414.708,324,418.331a.829.829,0,0,1-1.009-.6l-3.226-12.508a.829.829,0,0,1,.6-1.008l14.052-3.624a.829.829,0,0,1,1.009.6L338.65,413.7A.829.829,0,0,1,338.055,414.708Z",
	transform: "translate(-295.871 -335.598)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_679",
	"data-name": "Path 679",
	d: "M368.322,532.082l-14.052,3.624a.829.829,0,0,1-1.009-.595L350.037,522.6a.829.829,0,0,1,.6-1.009l14.052-3.624a.829.829,0,0,1,1.009.6l3.225,12.508a.829.829,0,0,1-.6,1.009Z",
	transform: "translate(-319.617 -427.681)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_680",
	"data-name": "Path 680",
	d: "M530.649,209.052H449.563a10.381,10.381,0,0,0-10.37,10.37v95.212A10.381,10.381,0,0,0,449.563,325h81.086a10.381,10.381,0,0,0,10.37-10.37V219.422a10.381,10.381,0,0,0-10.37-10.37Z",
	transform: "translate(-389.583 -185.347)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_681",
	"data-name": "Path 681",
	d: "M541.518,222.906H460.431a7.393,7.393,0,0,0-7.384,7.384V325.5a7.393,7.393,0,0,0,7.384,7.384h81.086A7.393,7.393,0,0,0,548.9,325.5V230.29A7.393,7.393,0,0,0,541.518,222.906Z",
	transform: "translate(-400.452 -196.216)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_94",
	"data-name": "Ellipse 94",
	cx: 18.929,
	cy: 18.929,
	r: 18.929,
	transform: "translate(130.655 113.382)",
	fill: "#7f8688"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_682",
	"data-name": "Path 682",
	d: "M870.273,668.669h-6.584v-6.584a2.469,2.469,0,1,0-4.938,0v6.584h-6.584a2.469,2.469,0,1,0,0,4.938h6.584v6.584a2.469,2.469,0,1,0,4.938,0v-6.584h6.584a2.469,2.469,0,0,0,0-4.938Z",
	transform: "translate(-711.635 -538.826)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_683",
	"data-name": "Path 683",
	d: "M651.417,453.141h-41a1.727,1.727,0,1,1,0-3.454h41a1.727,1.727,0,1,1,0,3.454Z",
	transform: "translate(-522.554 -374.132)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_684",
	"data-name": "Path 684",
	d: "M658.54,480.188H610.412a1.727,1.727,0,1,1,0-3.454H658.54a1.727,1.727,0,0,1,0,3.454Z",
	transform: "translate(-522.554 -395.352)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_685",
	"data-name": "Path 685",
	d: "M651.417,574.354h-41a1.727,1.727,0,1,1,0-3.454h41a1.727,1.727,0,1,1,0,3.454Z",
	transform: "translate(-522.554 -469.227)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_686",
	"data-name": "Path 686",
	d: "M658.54,601.4H610.412a1.727,1.727,0,0,1,0-3.454H658.54a1.727,1.727,0,0,1,0,3.454Z",
	transform: "translate(-522.554 -490.447)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_687",
	"data-name": "Path 687",
	d: "M518.221,451.982H503.709a.829.829,0,0,1-.828-.828V438.237a.829.829,0,0,1,.828-.828H518.22a.829.829,0,0,1,.828.828v12.917A.829.829,0,0,1,518.221,451.982Z",
	transform: "translate(-439.548 -364.5)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_688",
	"data-name": "Path 688",
	d: "M518.221,573.2H503.709a.829.829,0,0,1-.828-.828V559.45a.829.829,0,0,1,.828-.828H518.22a.829.829,0,0,1,.828.828v12.917A.829.829,0,0,1,518.221,573.2Z",
	transform: "translate(-439.548 -459.595)",
	fill: "#e6e6e6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_689",
	"data-name": "Path 689",
	d: "M690.854,318.206H660.623a1.727,1.727,0,1,1,0-3.454h30.231a1.727,1.727,0,0,1,0,3.454Z",
	transform: "translate(-561.946 -268.272)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_690",
	"data-name": "Path 690",
	d: "M697.977,345.254H660.623a1.727,1.727,0,1,1,0-3.454h37.354a1.727,1.727,0,0,1,0,3.454Z",
	transform: "translate(-561.946 -289.492)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_691",
	"data-name": "Path 691",
	d: "M531.369,305.382H503.5a.829.829,0,0,1-.828-.828V282.8a.829.829,0,0,1,.828-.828h27.871a.829.829,0,0,1,.828.828v21.751A.829.829,0,0,1,531.369,305.382Z",
	transform: "translate(-439.383 -242.557)",
	fill: "#7f8688"
})));
export default SvgEmptyStateAssetMenu;
